import { ItemModifierType } from "../components/Inventory/AddEditModifier/ItemModifierType";
import api from "./api";

export type DeleteItemModifierDto = {
  id: number | string;
};

/*get item Modifier main */

export const getModifieresForItem = async (
  itemid: string | number | undefined
) => {
  return await api.get(`/items/${itemid}/modifiers`);
};

/*get item Modifier search & filter */

export const getModifieresForItemApi = async (body: {
  itemid: string | number | undefined;
  q: string;
  isActive?: boolean;
}) => {
  let url = `/items/${body.itemid}/modifiers?q=${body.q.toString()}`;
  if (body.isActive !== undefined) {
    url += `&isActive=${body.isActive}`;
  }
  return await api.get(url);
};

/*delete item Modifier  */

export const deleteItemModifier = async (dto: DeleteItemModifierDto) => {
  return await api.delete(`/items/modifiers/${dto.id}`);
};

/*get byid item Modifier  */

export const getItemModifierById = async (itemId: string | undefined) => {
  return await api.get(`/items/modifiers/${itemId}`);
};

/*edit item Modifier  */

export const editItemModifier = async (
  itemModifierId: any,
  body: ItemModifierType
) => {
  return await api.put(`/items/modifiers/${itemModifierId}`, body);
};

/*create item Modifier  */

export const createItemModifier = async (
  itemModifierDetails: ItemModifierType
) => {
  return await api.post("/items/modifiers", itemModifierDetails);
};
